import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 692px;
  margin: 0 auto;

  > h1 {
    text-align: center;
    margin-bottom: 48px;
  }
`;

export const Form = styled.form`
  display: grid;
  gap: 48px 0;
  grid-template-areas: "nome" "text" "checks" "button";

  > :nth-child(1) {
    grid-area: nome;
  }

  > :nth-child(2) {
    grid-area: text;
    text-align: center;

    p {
      color: #2d2d2d;
      text-align: center;
      font-family: Mulish;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    }
  }

  > :nth-child(3) {
    grid-area: checks;
    display: flex;
    flex-direction: column;
    gap: 28px;
    margin: 0 auto;
  }

  > :nth-child(4) {
    grid-area: button;
    margin: 0 auto;
  }

  @media (min-width: 640px) {
    > :nth-child(3) {
      grid-area: checks;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`;
